(function () {
  function setOpen(step, open) {
    var trigger = step.querySelector(".tried-reasons__trigger");

    step.classList.toggle("is-open", open);

    if (trigger) {
      trigger.setAttribute("aria-expanded", open ? "true" : "false");
    }
  }

  function initList(list) {
    if (!list || list.dataset.triedReasonsInit === "true") {
      return;
    }

    list.dataset.triedReasonsInit = "true";

    list.addEventListener("click", function (event) {
      var trigger = event.target.closest(".tried-reasons__trigger");

      if (!trigger || !list.contains(trigger)) {
        return;
      }

      var step = trigger.closest(".tried-reasons__item");
      var isOpen = step.classList.contains("is-open");

      list.querySelectorAll(".tried-reasons__item.is-open").forEach(function (openStep) {
        if (openStep !== step) {
          setOpen(openStep, false);
        }
      });

      setOpen(step, !isOpen);
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll(".tried-reasons__list").forEach(initList);
  }

  initAll();

  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });
})();
